import cookies from '../../components/cookies.vue'
import { i18n, loadLanguageAsync} from '../i18n'
import Vue from 'vue'
const Constructor = Vue.extend(cookies);

let cart;

const dialog = async(callback) => {
    await loadLanguageAsync('cookies')
    if (!cart) {
        cart = new Constructor({
            i18n,
            el: document.createElement('div'),
        });
    }
    cart.dialogVisible = true;
    cart.success = function () {
        callback()  
    }

    document.body.appendChild(cart.$el);
};

export default dialog;


// WEBPACK FOOTER //
// ./resources/js/lib/dialog/cookies.js